<template>
  <fa
    :icon="['fas', 'spinner-third']"
    :style="{ color: '#8EBEF2' }"
    class="fa-spin"
  />
</template>
